import React from 'react';

const Dashboard = () => {
    return (
        <div className="dashboard">
            <div className="sidebar">
                {/* Sidebar menu items */}
            </div>
            <div className="content">
                {/* Dashboard content */}
            </div>
        </div>
    );
};

export default Dashboard;